import React, {useEffect, useState} from "react";
import {run} from "../../../utils/function-util";
import {makeStyles} from "@material-ui/core/styles";
import {getDisplayedSubscriptionsCount} from "../../../api/organization-unit-functions";
import {SubscriptionUsage} from "./SubscriptionUsage";

const useStyles = makeStyles(theme => ({
    orgUnitDetailSubscriptionOverview: {
        'display': 'flex',
        'justify-content': 'space-around',
        'flex-wrap': 'wrap',
    },
}));
export const SubscriptionsOverview = ({ organizationId, organizationUnitId, refresh }: any) => {
    const [subscriptionUsages, setSubscriptionUsages] = useState([]);
    const classes = useStyles();
    const fetch = getDisplayedSubscriptionsCount;
       useEffect(run(async () => await fetch(organizationId, organizationUnitId), setSubscriptionUsages), [organizationId, organizationUnitId, refresh]);
       return (<div className={classes.orgUnitDetailSubscriptionOverview}>
                        {subscriptionUsages.map(usage => <SubscriptionUsage className={(classes as any).control} key={organizationUnitId + (usage as any).type} type={(usage as any).type} total={(usage as any).total} used={(usage as any).used} available={(usage as any).available}>
                </SubscriptionUsage>)}
        </div>);
};
